import { Box, FormControl, FormGroup, FormHelperText } from "@mui/material";
import { Label } from "../Label";

interface IProps {
  label: React.ReactNode;
  children: React.ReactNode;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  required?: boolean;
}

const CheckboxGroup: React.FC<IProps> = (props) => {
  const {
    label,
    children,
    disabled = false,
    error,
    helperText,
    required = false,
  } = props;

  return (
    <FormControl error={error} disabled={disabled}>
      <Label required={required}>{label}</Label>
      <Box sx={{ marginLeft: "4px" }}>
        <FormGroup>{children}</FormGroup>
      </Box>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export { CheckboxGroup };
